import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../layout/Index.vue'
Vue.use(VueRouter)
// import Router from 'vue-router'
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
const routes = [
  {
    path: '/',
    name: 'index',
    redirect: '/index',
    component: index,
    children: [
      // 首页
      {
        path: '/index',
        name: '公司首页',
        component: () => import(/* webpackChunkName: "about" */ '../views/index.vue')
      },
      // 产品与业务
      {
        path: '/business',
        name: '集团业务',
        component: () => import(/* webpackChunkName: "about" */ '../views/business.vue')
      },
      {
        path: '/business',
        name: 'Group Business',
        component: () => import(/* webpackChunkName: "about" */ '../views/business.vue')
      },
      // 新闻中心
      {
        path: '/news',
        name: '新闻中心',
        component: () => import(/* webpackChunkName: "about" */ '../views/news.vue')
      },
      {
        path: '/news',
        name: 'News',
        component: () => import(/* webpackChunkName: "about" */ '../views/news.vue')
      },
      // 加入我们
      {
        path: '/us',
        name: '加入我们',
        component: () => import(/* webpackChunkName: "about" */ '../views/us.vue')
      },
      {
        path: '/us',
        name: 'Join Us',
        component: () => import(/* webpackChunkName: "about" */ '../views/us.vue')
      },
      // 概括
      {
        path: '/generalization',
        name: '关于我们',
        component: () => import(/* webpackChunkName: "about" */ '../views/generalization.vue')
      },
      {
        path: '/generalization',
        name: 'About Group',
        component: () => import(/* webpackChunkName: "about" */ '../views/generalization.vue')
      },
      // 登录
      {
        path: '/login',
        component: () => import(/* webpackChunkName: "about" */ '../views/login.vue')
      },
      // 更改密码
      {
        path: '/changepass',
        component: () => import(/* webpackChunkName: "about" */ '../views/changepass.vue')
      }
    ]
  },
  {
    path: '/newDetails',
    component: () => import(/* webpackChunkName: "about" */ '../views/newDetails.vue')
  },
  {
    path: '/tohome',
    component: () => import(/* webpackChunkName: "about" */ '../views/tohome.vue')
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "error" */ '../views/Error')
  }
]

// component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')

const router = new VueRouter({
  routes
})
export default router
